module.exports = __webpack_public_path__ + "static/media/icon-graph-1.e6ca82b2.svg";